<mat-toolbar>
  <div class="toolbar-left">
    <div class="logo-container">
      <a routerLink="{{ sessionService.isLoggedIn ? '/landing' : '/login' }}" routerLinkActive="active">
        <img src="app/shared/assets/images/epicare_logo.png" alt="epicare logo" class="logo" />
      </a>
    </div>
    <div class="header-text">
      <div class="text-group">
        <h1 class="title">{{ "header.title" | translate }}</h1>
        <p class="subtitle">{{ "header.subtitle" | translate }}</p>
      </div>
    </div>
  </div>

  <div class="toolbar-right">
    <span class="user-role">{{ "header.biobankPortal" | translate }}</span>
    <button
      mat-icon-button
      aria-label="icon-button with person icon"
      [matMenuTriggerFor]="accountMenu"
      color="primary"
      id="toolbar-account-button"
    >
      <mat-icon>person</mat-icon>
    </button>
  </div>
  <span class="spacer"></span>
  <mat-menu #accountMenu="matMenu">
    <app-account-menu></app-account-menu>
  </mat-menu>
</mat-toolbar>
